export default {
  ["Дата начала продаж {date}"]: (date?: string) => `Sales start on ${date}`,
  ["Закрыть"]: "Close",
  ["Рекламный слайдер"]: "Advertisement slider",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Use arrow keys to switch slides.",
  ["Ещё"]: "More",
  ["Ещё {number}"]: (number?: number) => `${number} more`,
  ["Убрать"]: "Remove",
  ["Меню"]: "Menu",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `From ${data?.min} to ${data?.max} ${(data?.max || 0) > 1 ? "characters" : "character"}`,
  ["Минимум {count} символ"]: (count: number | undefined = 0) =>
    `At least ${count} ${count > 1 ? "characters" : "character"}`,
  ["Выбрать из списка"]: "Select from list",
  ["развернуто"]: "Expanded",
  ["свернуто"]: "Collapsed",
  ["Модальное окно"]: "Modal window",
  ["Выбран"]: "Selected",
  ["Не выбран"]: "Not selected",
  ["Свернуть"]: "Collapse",
  ["Эксклюзив"]: "Exclusive",
  ["Хит продаж"]: "Bestseller",
  ["Новинка"]: "New release",
  ["Все книги, получившие эту награду"]: "All books that received this award",
  ["Предыдущий слайд"]: "Previous slide",
  ["Следующий слайд"]: "Next slide",
  ["Оценить книгу на {count} балл из 5"]: (count: number | undefined = 0) =>
    `Rate the book ${count} ${count > 1 ? "points" : "point"} out of 5`,
  ["Снять оценку"]: "Remove rating",
  ["{star} звезда из 5"]: (star: number | undefined = 0) =>
    `${star} ${star > 1 ? "stars" : "star"} out of 5`,
  ["предыдущий таб"]: "Previous tab",
  ["следующий таб"]: "Next tab",
};
